import { RestProvider, RestService } from '../rest/rest.service';
import { Models } from '@ibexfusion/models';
import { RestfulService } from '../rest/restful';
import { Injectable } from '@angular/core';

@Injectable()
export class DriverRouteExecutionService extends RestfulService<Models.DriverRouteExecution> {

  constructor(public restService: RestService) {
    super(Models.DriverRouteExecution);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('driver-route-executions');
  }

}
